import React from 'react';
import { LoadableBadges } from './Badges/loadable';
import { LoadableCertificateLink } from './CertificateLink/loadable';
import { ReplacingPortal } from '../../components/Portal/component';

export const BadgeCertificateContainer = () => (
  <>
    <div id="course-badges-mount">
      <LoadableBadges />
    </div>
    <div id="certificate-link-mount">
      <LoadableCertificateLink />
    </div>
  </>
);

export const BadgeCertificateContainerPortal = () => {
  const mount = document.getElementById('progress-badge-container');
  if (mount) {
    return (
      <ReplacingPortal container={mount}>
        <BadgeCertificateContainer />
      </ReplacingPortal>
    );
  }
  return null;
};
